import React from "react";
import { Link } from "react-router-dom";
import DiselFilterPageStore from "../../Components/DiselFilterPageStroe/DiselFilterPageStore";
import { IoIosArrowForward } from "react-icons/io";

const DeselFilter = () => {
  return (
    <div>
      <div className="bg_banner_about ">
        <h1>Diesel Filter</h1>
        <div className="bread_craum">
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Home
          </Link>
          <IoIosArrowForward style={{ color: "#0F172B", marginTop: "4px" }} />
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Disel Filter
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <h2
              style={{
                borderColor: "orange",
                width: "fit-content",
                borderLeftStyle: "solid",
                backgroundColor: "#474065",
                padding: "5px",
                color: "white",
                marginTop: "14px",
                marginBottom: "36px",
              }}
            >
              Diesel Filter
            </h2>
            <DiselFilterPageStore />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeselFilter;
